import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-entrance-exit-entry',
  templateUrl: './manual-entrance-exit-entry.component.html',
  styleUrls: ['./manual-entrance-exit-entry.component.css'],
  standalone: false,
})
export class ManualEntranceExitEntryComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly reflectDataLink: string = AppConst.ROUTING_LINK_MANUAL_REFLECT_DATA;

  readonly manualSelectEntranceExitEntryDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SELECT_ENTRANCE_EXIT_ENTRY_DIALOG;
  readonly manualEntranceExitTransitDialogLink: string = AppConst.ROUTING_LINK_MANUAL_ENTRANCE_EXIT_TRANSIT_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
